<template>
  <div class="content">
    <div class="border-card">
      <h3 class="font-85">请选择您要为谁问诊</h3>
      <div
        class="pat-card patient-box"
        :class="{active:patid==item.id}"
        v-for="(item,index) in patList"
        :key="index"
        @click="changePat(item.id)"
      >
        <p class="font-85">{{item.realname}}</p>
        <p class="pat-ages font-65">
          <i class="icon icon-pat-male" :class="{'icon-pat-female':item.sex==2}"></i>
          {{item.sex==1?'男':'女'}} {{item.age}}岁
        </p>
      </div>
      <div class="pat-card add-card" v-if="patList.length<6" @click="addPat">
        <i class="icon icon-pat-add"></i>
        <div class="pat-ages pat-ages-add">添加就诊人</div>
      </div>
      <br class="clear" />
    </div>

    <div class="border-card">
      <h3>是否就该病情到医院就诊过</h3>
      <div class="pat-card jiuzhen font-85" :class="{active:daojiu==2}" @click="daoyi(2)">否</div>
      <div class="pat-card jiuzhen font-85" :class="{active:daojiu==1}" @click="daoyi(1)">是</div>
      <br class="clear" />
    </div>

    <div class="bottom">
      <div class="checks">
        <i class="icon icon-check" :class="{'icon-checked':tongyi == 1}" @click="xieyi"></i>
        <p>
          开始问诊即代表您已阅读并同意
          <span @click="handlePdf(1)" style="color:rgba(24,144,255,1);">《用户注册协议》(包含互联网诊疗风险告知及知情同意书)</span>及
          <span @click="handlePdf(2)" style="color:rgba(24,144,255,1);">《法律声明与隐私政策》</span>
        </p>
      </div>
      <div class="btns">
        <button class="prop-btn font-65 flex_c_c" @click="proppage">上一步</button>
        <button class="submit-btn flex_c_c" :class="{'active':patid!=0}" @click="submitPat">开始问诊</button>
      </div>
    </div>
  </div>
</template>

<script>
import http from "../../request/http";

export default {
  name: "select_patient.vue",
  data() {
    return {
      patList: [],
      patid: 0,
      daojiu: '',
      tongyi: 1,
      doctorid: "",
      service_type:0
    };
  },
  created() {
    if (this.$route.query.type == 1) {
      document.title = "图文问诊";
    } else if (this.$route.query.type == 2) {
      document.title = "电话问诊";
    }
    this.service_type = this.$route.query.type;
  },
  mounted() {
    this.loadPat();
    this.doctorid = this.$route.query.doctorid;
  },
  methods: {
    handlePdf(type){
      let pdf = ''
      if(type == 1){
        pdf = 'user_register_protocol.pdf'
      }else if(type == 2){
        pdf = 'legal_notice.pdf'
      }
      this.$router.push({
        name:'pdf_template',
        query:{
          pdf:pdf
        }
      })
    },
    loadPat() {
      http.post("/api/wap/user/patientlist").then((res) => {
        console.log(res);
        this.patList = res.data;
        this.patid = res.data[0].id;
      });
    },
    addPat() {
      this.$router.push({
        name: "patient_edit",
        query: {
          from: "select_patient",
          type: this.$route.query.type,
          doctorid: this.$route.query.doctorid,
        },
      });
    },
    proppage(){
      this.$router.push({
        path:'/doctor_content',
        query:{
          doctorid:this.doctorid
        }
      })
    },
    changePat(id) {
      this.patid = id;
    },
    daoyi(dao) {
      this.daojiu = dao;
    },
    xieyi() {
      if (this.tongyi == 1) {
        this.tongyi = 2;
      } else {
        this.tongyi = 1;
      }
    },
    submitPat() {
      if (this.patid == "" && this.patList.length > 0) {
        this.$toast.center("请选择就诊人");
      } else if (this.patid == "" && this.patList.length == 0) {
        this.$toast.center("请添加就诊人");
      } else if (this.daojiu == "") {
        this.$toast.center("请选择是否到医院就诊过");
      } else if (this.tongyi == 2) {
        this.$toast.center("请勾选您已阅读并同意以下协议");
      } else {
        this.$router.push({
          name: "wenzhen_order_pay",
          query: {
            patid: this.patid,
            daojiu: this.daojiu,
            tongyi: this.tongyi,
            doctorid: this.doctorid,
            type:this.service_type
          },
        });
      }
    },
  },
};
</script>

<style scoped>
@import "./patient.css";
.patient-box {
  padding: 0.8rem 1rem;
  height: 4.5rem;
  box-sizing: border-box;
}
.add-card{
  height: 4.5rem;
}
.patient-box p {
  height: 1.4rem;
  line-height: 1.4rem;
  font-size: 1rem;
  margin-bottom: 0.2rem;
}
.patient-box .pat-ages,
.pat-card .pat-ages-add {
  height: 1.2rem;
  line-height: 1.2rem;
  margin-bottom: 0;
}
.checks p {
  width: calc(100% - 1.4rem);
}
.pat-card{
  width: calc(50vw - 2rem);
}
.submit-btn{
  background-color: rgba(245, 245, 245, 1);
  color:rgba(0, 0, 0, 0.25)
}
.submit-btn.active{
  background: #1890FF;
  color: #fff;
}
.content{
  width: 100%;
  height: 100vh;
  padding-bottom: 7.65rem;
  overflow-x: hidden;
  overflow-y: auto;
}
.patient-box.active{
  background-color: rgba(24, 144, 255, 0.05);
  border: 0.05rem solid rgba(24, 144, 255, 1);
}
.jiuzhen.active{
  background-color: rgba(250, 250, 250, 1);
  border: 0.05rem solid rgba(24, 144, 255, 1);
  color: rgba(24, 144, 255, 1);
}
.flex_c_c{
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/patient/select_patient.vue